<section class="communities-preview-section py-5">
  <div class="container">
    <div class="row text-center section-header-row">
      <div class="col-12">
        <h2 class="section-title">Built for membership organizations like yours</h2>
        <p class="section-subtitle">From medical societies to founder networks, MemberTrace helps organizations manage members, events, directories, and payments in one place.</p>
      </div>
    </div>
    <div class="row g-4">
      <div class="col-md-6 col-lg-4" *ngFor="let community of communities">
        <mat-card class="community-preview-card h-100" [routerLink]="community.route">
          <mat-card-content class="p-4">
            <mat-icon color="primary" class="card-icon">{{ community.icon }}</mat-icon>
            <h3 class="card-title">{{ community.title }}</h3>
            <p class="card-description">{{ community.description }}</p>
            <span class="card-link">Learn more <mat-icon class="arrow">arrow_forward</mat-icon></span>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="row cta-row">
      <div class="col-12 text-center cta-buttons">
        <button mat-stroked-button color="primary" routerLink="/communities">Explore communities</button>
        <button mat-flat-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }">Book a walkthrough</button>
      </div>
    </div>
  </div>
</section>
